module.exports = __webpack_public_path__ + "img/No_Image_Available.e93bd149.png";